import { GameWithScore, StudentResultsStore } from "../../../react/students/StudentResultsStore"

export class AddictionRoadStore {

    private static innerInstance: AddictionRoadStore

    addictedGuess: boolean

    static get instance() {
        return this.innerInstance || (this.innerInstance = new this())
    }

    setAddictedGuess = (addicted: boolean) => {
        this.addictedGuess = addicted
    }

    static get getAddictedGuess(): boolean {
        return AddictionRoadStore.instance.addictedGuess
    }

    static saveUserScore = (smoked: number) => StudentResultsStore.instance.addScore(GameWithScore.ADDICTION_ROAD, smoked)

    static getScores = () => StudentResultsStore.instance.findRecentScores(GameWithScore.ADDICTION_ROAD).slice(0, 6)

}
